export const ASSETINSPECTIONCATEGORY_LOADING = "ASSETINSPECTIONCATEGORY_LOADING";
export const ASSETINSPECTIONCATEGORY_RESET = "ASSETINSPECTIONCATEGORY_RESET";
export const GET_ASSETINSPECTIONCATEGORY = "GET_ASSETINSPECTIONCATEGORY";
export const GET_ASSETINSPECTIONCATEGORY_SUCCESS = "GET_ASSETINSPECTIONCATEGORY_SUCCESS";
export const GET_ASSETINSPECTIONCATEGORY_FAIL = "GET_ASSETINSPECTIONCATEGORY_FAIL";
export const DELETE_ASSETINSPECTIONCATEGORY = "DELETE_ASSETINSPECTIONCATEGORY"
export const DELETE_ASSETINSPECTIONCATEGORY_SUCCESS = "DELETE_ASSETINSPECTIONCATEGORY_SUCCESS"
export const DELETE_ASSETINSPECTIONCATEGORY_FAIL = "DELETE_ASSETINSPECTIONCATEGORY_FAIL"
export const UPDATE_ASSETINSPECTIONCATEGORY = "UPDATE_ASSETINSPECTIONCATEGORY"
export const UPDATE_ASSETINSPECTIONCATEGORY_SUCCESS = "UPDATE_ASSETINSPECTIONCATEGORY_SUCCESS"
export const UPDATE_ASSETINSPECTIONCATEGORY_FAIL = "UPDATE_ASSETINSPECTIONCATEGORY_FAIL"
export const ADD_NEW_ASSETINSPECTIONCATEGORY = "ADD_NEW_ASSETINSPECTIONCATEGORY"
export const ADD_ASSETINSPECTIONCATEGORY_SUCCESS = "ADD_ASSETINSPECTIONCATEGORY_SUCCESS"
export const ADD_ASSETINSPECTIONCATEGORY_FAIL = "ADD_ASSETINSPECTIONCATEGORY_FAIL"
export const ASSETINSPECTIONCATEGORY_RESET_CREATE = "ASSETINSPECTIONCATEGORY_RESET_CREATE"